import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import Table from '../Table/index.js';
import Message from '../Message/index.js';
import styles from './styles.css.js';

function TableView(props) {
  const {
    className,
    pending,
    filtered,
    errored,
    emptyIcon,
    emptyMessage,
    pendingMessage,
    filteredEmptyIcon,
    filteredEmptyMessage,
    erroredEmptyIcon,
    erroredEmptyMessage,
    messageActions,
    data,
    contentClassName,
    compactEmptyMessage,
    compactPendingMessage,
    messageShown = false,
    messageIconShown = false,
    overflowContainerClassName,
    onReload,
    ...otherTableProps
  } = props;
  const empty = !(data !== null && data !== void 0 && data.length && data.length > 0);
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.tableView, className, empty && styles.empty, pending && styles.pending)
  }, /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.overflowContainer, overflowContainerClassName)
  }, /*#__PURE__*/React.createElement(Table, _extends({
    className: _cs(styles.table, contentClassName),
    data: errored ? undefined : data
  }, otherTableProps))), /*#__PURE__*/React.createElement(Message, {
    empty: empty,
    errored: errored,
    pending: pending,
    filtered: filtered,
    emptyIcon: emptyIcon,
    emptyMessage: emptyMessage,
    pendingMessage: pendingMessage,
    filteredEmptyIcon: filteredEmptyIcon,
    filteredEmptyMessage: filteredEmptyMessage,
    erroredEmptyIcon: erroredEmptyIcon,
    erroredEmptyMessage: erroredEmptyMessage,
    compactPendingMessage: compactPendingMessage,
    compactEmptyMessage: compactEmptyMessage,
    messageHidden: !messageShown,
    messageIconHidden: !messageIconShown,
    onReload: onReload,
    actions: messageActions
  }));
}

var index = genericMemo(TableView);

export { index as default };
//# sourceMappingURL=index.js.map
